import Service from './service';
import { AxiosResponse } from 'axios';
const Config = require('Config');

const langTranslation: { [key: string]: string } = {
  es: 'spanish',
  en: 'english',
};

interface Attribute {
  action: 'set' | 'remove';
  key: string;
  value: string;
}

export interface DeviceInformationPayloadV2 {
  action: string;
  attributes: Attribute[];
  deviceType: string;
  device_id: string;
  email: string;
}

interface DeviceInformationPayload {
  'airship_channel_id': string;
  email: string;
  attribute?: {
    value?: string;
    key: string;
    action: string;
  };
  deviceType: string;
  action?: string;
  'device_id'?: string;
  attributes?: {
    value?: string;
    key: string;
    action: string;
  }[];
}

interface DeviceInformationResponse {
  message: string;
  statusCode: number;
}

class AirshipService extends Service {
  constructor() {
    super(Config.airshipServiceUrl);
  }

  async setDeviceLanguage(
    airshipChannelId: string,
    email: string,
    code: string,
  ): Promise<DeviceInformationResponse | undefined> {
    try {
      const payload: DeviceInformationPayload = {
        airship_channel_id: airshipChannelId,
        email,
        attribute: {
          value: langTranslation[code],
          key: 'rtspro_selected_language',
          action: 'set',
        },
        deviceType: 'web',
      };
      const response: AxiosResponse = await this.axios.post('/channel', payload);
      if (!response || response.status < 200 || response.status > 300) {
        throw new Error();
      }
      return response.data;
    } catch (e) {
      console.log('Error setting device attributes: ', e);
    }
  };

  async updateDeviceInformation(
    airshipChannelId: string,
    email: string,
    code: string,
    deviceId: string,
  ): Promise<DeviceInformationResponse | undefined> {
    try {
      const payload: DeviceInformationPayloadV2 = {
        email,
        device_id: deviceId,
        action: 'update',
        attributes: [{
          value: langTranslation[code],
          key: 'rtspro_selected_language',
          action: 'set',
        }],
        deviceType: 'web',
      };
      if (airshipChannelId) {
        payload['airship_channel_id'] = airshipChannelId;
      }
      const response: AxiosResponse = await this.axios.post('/channel', payload);
      if (!response || response.status < 200 || response.status > 300) {
        throw new Error();
      }
      return response.data;
    } catch (e) {
      console.log('Error setting device attributes: ', e);
    }
  };

  async deleteDeviceInformation(airshipChannelId: string, email: string)
    : Promise<DeviceInformationResponse | undefined> {
    try {
      const payload: DeviceInformationPayload = {
        airship_channel_id: airshipChannelId,
        email,
        attribute: {
          key: 'rtspro_selected_language',
          action: 'remove',
        },
        deviceType: 'web',
      };
      const response: AxiosResponse = await this.axios.post('/channel', payload);
      if (!response || response.status < 200 || response.status > 300) {
        throw new Error();
      }
      return response.data;
    } catch (e) {
      console.log('Error removing device attributes: ', e);
    }
  };

  async createDeviceInfo(email: string, deviceId: string, code: string, airshipChannelId: string) {
    try {
      const payload: DeviceInformationPayload = {
        airship_channel_id: airshipChannelId,
        device_id: deviceId,
        email,
        action: 'create',
        attributes: [{
          key: 'rtspro_selected_language',
          action: 'set',
          value: langTranslation[code],
        }],
        deviceType: 'web',
      };
      const response: AxiosResponse = await this.axios.post('/channel', payload);
      if (!response || response.status < 200 || response.status > 300) {
        throw new Error();
      }
      return response.data;
    } catch (e) {
      console.log('Error creating device info doc: ', e);
    }
  }
};

export default new AirshipService();
